export default "__VITE_ASSET__CjGA2LUz__"